
document.addEventListener('DOMContentLoaded', ()=>{
    // Initialize the YouTube manager with the channel ID
    // Temporarily disabled - will be enabled when videos section is needed
    /*
  const channelId = 'UCTz-XSaHkIHhAJZjwJhzwKw';
  const youtubeManager = new YouTubeManager(channelId, 'videos-section');
  */ // Additional initialization code can be added here
    console.log('Vibe Coding Nation website initialized');
});


//# sourceMappingURL=vibe-coding-nation.c1fd9a29.js.map
